import { Injectable } from '@angular/core';
import { Auth, signInWithCustomToken } from '@angular/fire/auth';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FirebaseAuthenticationService } from '../../../infraestructure/firebase/firebase-auth.service';

@Injectable({ providedIn: 'root' })
export class AuthFirebaseService {

    constructor(
        private firebaseAuthService: FirebaseAuthenticationService,
        private auth: Auth
    ) {}

    public signIn(): Observable<void> {
        return this.firebaseAuthService.getToken().pipe(
            switchMap(tokenFirebase =>
                from(signInWithCustomToken(this.auth, tokenFirebase.token))
            ),
            switchMap(() => from(Promise.resolve()))
        );
    }

}